// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23uOZ","clinicsSelect":"styles_clinicsSelect__2BvTM"};